module.exports = __webpack_public_path__ + "img/layout_boubel.d301085c.svg";